import { createPortal } from "react-dom"
import { toast } from "react-toastify"
import dayjs from "dayjs"
import styled from "styled-components"

import { useFulfillOrderNewMutation } from "store/api/ordersApi"
import { useFulfillVendorOrderMutation } from "store/api/vendorApi"
import { ApiTypes } from "types"
import { ReactComponent as IconOrderConfirmation } from "assets/svg/modal-icon-order-confirmation.svg"

import getErrorMessage from "utils/getErrorMessage"
import { getProductTypeLabel } from "utils/getProductTypeLabel"
import { ModalLayout } from "layouts/ModalLayout"
import { ModalHeader } from "components/common/ModalHeader"

const OrderItem = styled.li`
  margin-bottom: 12px;
  font-family: "Inter";
  list-style: none;
  font-weight: 300;
  padding-left: 20px;
  padding-right: 20px;

  &:first-child {
    padding-top: 25px;
    padding-bottom: 5px;
  }

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 25px;
  }
`

const OrderItemName = styled.span`
  color: var(--text-muted);
`

const OrderItemValue = styled.span`
  display: inline-flex;
  margin-left: 8px;
  font-weight: 400;
`

interface Props {
  isVendor?: boolean
  order: ApiTypes.Model.OrderNew
  onCancel: () => void
  onSuccess: () => void
}

export const OrderFulfillmentModal = ({ order, onCancel, onSuccess, isVendor }: Props) => {
  const [triggerFulfillOrderNew, { isLoading }] = isVendor
    ? useFulfillVendorOrderMutation()
    : useFulfillOrderNewMutation()

  const totalQuantity = order.items[0].quantity

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    try {
      const res = await triggerFulfillOrderNew(order.items[0].id)
      const error = getErrorMessage(res?.error)
      if (error) {
        toast.error(error)
      } else {
        toast.success("Order has been successfully fulfilled!")
        onSuccess()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      {createPortal(
        <ModalLayout width="450px" isFetching={isLoading} onConfirm={onSubmit} onCancel={onCancel}>
          <ModalHeader
            title="Order fulfillment confirmation"
            subtitle="Are you sure you want to confirm the fulfillment of the order?"
          >
            <IconOrderConfirmation />
          </ModalHeader>
          <div>
            <ul>
              <OrderItem>
                <OrderItemName>{getProductTypeLabel(order.items[0].product_type)} quantity:</OrderItemName>
                <OrderItemValue>{totalQuantity}</OrderItemValue>
              </OrderItem>
              <OrderItem>
                <OrderItemName>Order creations date:</OrderItemName>
                <OrderItemValue>{dayjs(order.create_date).format("MM.DD.YYYY")}</OrderItemValue>
              </OrderItem>
            </ul>
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
